import HttpClient from '@/services/http-client'

class TestTableService extends HttpClient {
  async create(payload) {
    return this.rest.post('/v1/test-tables', payload)
  }

  async show(id) {
    return this.rest.get('/v1/test-tables/' + id)
  }

  async list(page = 1, limit = 1000, text = null) {
    return this.rest.get('/v1/test-tables', {
      params: {
        page,
        limit,
        q: text
      }
    })
  }

  async update(payload) {
    return this.rest.patch('/v1/test-tables/' + payload.id, payload)
  }

  async delete(id) {
    return this.rest.delete('/v1/test-tables/' + id)
  }
}

export default () => new TestTableService()
